<template>
  <app-layout ref="lo" title="Penyedia">
    <template #header>
      <BreadCrumb :breadcrumb="$page.props.bc"/>
    </template>

    <div class="py-4">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
          <section class="text-gray-600 body-font">
            <div class="container px-5 py-5 mx-auto">
              <div class="flex flex-wrap w-full mb-5 flex-col">

                <!--                                    <input type="hidden"  v-model="form.id" id="id">-->
                <Accordion :multiple="true" :activeIndex="[0]">
                  <AccordionTab header="Data Penetapan" :disabled="true">
                    <div class="">
                      <div class="field w-full px-3 mb-3">

                        <!--                                                <ButtonShow @click="visible1 = true" />-->
                        <!--                                                <Dialog v-model:visible="visible1" modal :style="{ width: '50vw' }">-->
                        <pdf v-bind:src="'/storage/'+handleHashing('penetapan_role')+'/'+penetapanRole.file_sk"/>
                        <!--                                                </Dialog>-->
                      </div>

                    </div>
                  </AccordionTab>
                  <AccordionTab header="Data Pegawai">
                    <div class="">
                      <div class="form-group">
                        <ConfirmDialog></ConfirmDialog>
                        <DataTable :value="penetapanRoleDetail" tableStyle="min-width: 50rem">
                          <Column v-for="col of columns" :key="col.field" :field="col.field"
                                  :header="col.header"></Column>
                          <!--                                                    <Column field="id" header="aksi" :sortable="true">-->
                          <!--                                                        <template #body="slotProps">-->

                          <!--                                                            <ButtonDelete label="hapus" @click="deletePenyediaPegawai(slotProps.data)" />-->
                          <!--                                                        </template>-->
                          <!--                                                    </Column>-->
                        </DataTable>
                      </div>
                    </div>
                  </AccordionTab>

                </Accordion>

                <div class="mt-6 lg:w-full md:w-full" v-if="$page.props.sessions_role?.name =='kakpbj'">
                  <div class="w-full px-3 text-center">
                    <div class="card flex justify-center flex-wrap gap-3">
                      <Button @click="verifikasi($event)" label="Verifikasi"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import {defineComponent} from "vue";
import AppLayout from "@/Layouts/AppLayout";
import BreadCrumb from "@/Components/BreadCrumb";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input.vue";
import InputError from "@/Components/InputError.vue";
import ButtonSave from "@/Components/ButtonSave.vue";
import InputMask from 'primevue/inputmask';
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import FileUpload from 'primevue/fileupload';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import ButtonShow from "@/Components/ButtonShow";
import Button from 'primevue/button';
import ButtonDelete from "@/Components/ButtonDelete";
import pdf from 'pdfvuer';
import Dialog from 'primevue/dialog';
import ConfirmPopup from 'primevue/confirmpopup';
import md5Hex from "md5-hex";
import {Pesan} from "@/constants";


export default defineComponent({
  components: {
    AppLayout,
    BreadCrumb,
    JetLabel,
    Input,
    InputError,
    ButtonSave,
    InputMask,
    Accordion,
    AccordionTab,
    FileUpload,
    DataTable,
    Column,
    ButtonShow,
    pdf,
    Dialog,
    ButtonDelete,
    ConfirmPopup,
    Button,

  },
  props: {
    penyedia: Array,
    penetapanRole: Array,
    penetapanRoleDetail: Array,
  },
  data() {
    return {

      visible1: false,
      columns: [
        {field: 'user.fullname', header: 'Nama Pegawai'},
        {field: 'user.identity', header: 'NIP Pegawai'},
        // { field: 'id', header: 'status' },
      ],


      // Confirm : useConfirm(),

    };
  },
  mounted() {

  },
  methods: {

    handleHashing(data) {
      this.hashedMessage = md5Hex(data);
      // console.log(md5Hex(data));
      return this.hashedMessage;
    },
    verifikasi: function (event) {
      this.$confirm.require({
        target: event.currentTarget,
        message:
            "Apakah akan Verifikasi Penetapan Role ini ?",
        icon: "pi pi-info-circle",
        acceptClass: "p-button-info",
        accept: () => {

          let cek = true;
          let cek_aktif = true;
          let penetapanRole = this.penetapanRole;
          if (penetapanRole.status == '1') {
            cek = false;
          }
          if (penetapanRole.is_aktif == '0') {
            cek_aktif = false;
          }

          // update data
          if (cek == false) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: 'data sudah diverifikasi',
              life: 3000,
            });
            return false;
          }
          if (cek_aktif == false) {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: 'data tidak aktif',
              life: 3000,
            });
            return false;
          }
          axios
              .post(route("penetapan.verifikasi"), {
                id: penetapanRole.id,
              })
              .then((response) => {
                this.$toast.add({
                  severity: "success",
                  summary: "Success",
                  detail: Pesan.success,
                  life: 3000,
                });
                window.location.reload();
              })
              .catch((error) => {
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: Pesan.error,
                  life: 3000,
                });
              });
        },
        reject: () => {
          //
        },
      });

    },
  },

});
</script>
